export const DS_DAY_1_FIELDS  = [
  "statusCorrect",
  "statusResponse",
  "deliveryCode",
  "deliveryCodeResponse",
  "epImaging",
  "epImagingResponse",
  "day1F18Note",
];

export const DS_DAY_2_FIELDS  = [
  "noMovement",
  "dateLastMovement",
  "noMovementSteps",
  "suffixBill",
  "suffixBillSteps",
  "spotTrailer",
  "freightLeft",
  "day2F18Note",
];
export const DS_DAY_3_FIELDS  = [
  "bolCheck",
  "bolSteps",
  "bolDiscrepancies",
  "pumCheck",
  "pumManifest",
  "pumDiscrepancy",
  "shipperLoad",
  "shipperDiscrepancy",
  "lineHaulManifest",
  "numbersReview",
  "interviewWorkers",
  "workerSteps",
  "consigneePhone",
  "consigneeName",
  "consigneeShort",
  "itemNumbers",
  "orderReceived",
  "freightLabeled",
  "shipperPhone",
  "shipperName",
  "shippedDetails",
  "shortShipped",
  "productValue",
  "multiShipments",
  "callDriver",
  "adeDelivery",
  "freightNose",
  "outOfOrdinary",
  "day3F18Note",
];
export const DS_DAY_4_FIELDS  = [
  "check7818",
  "details7818",
  "cameraFindings",
  "day4F18Note",
];
export const DS_DAY_5_FIELDS  = [
  "callSameDays",
  "callSameDaysDataset",
  "freightTerminalLeadInquiries",
  "contactTerminals",
  "day5F18Note",
];
export const DS_DAY_10_FIELDS  = ["followUp", "followUpDetails", "day10F18Note"];
export const DS_DAY_15_FIELDS  = [
  "check7818_2",
  "details7818_2",
  "highValue",
  "day15F18Note",
];
export const DS_DAY_20_FIELDS  = [
  "finalReCheck",
  "detailsOfSearch",
  "day20F18Note",
];


export const DS_ALL_INVESTIGATION_FIELDS_GROUPED  = [
  DS_DAY_1_FIELDS,
  DS_DAY_2_FIELDS,
  DS_DAY_3_FIELDS,
  DS_DAY_4_FIELDS,
  DS_DAY_5_FIELDS,
  DS_DAY_10_FIELDS,
  DS_DAY_15_FIELDS,
  DS_DAY_20_FIELDS,
];
